import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Modal, ModalBody } from "reactstrap";
import TooltipButton from "../tooltip-button";
import "./css/index.scss";

const Disclaimer = ({
  title,
  text,
  acepptButtonText,
  cancelButtonText,
  onAccept,
  onCancel,
  icon,
  visible
}) => {
  const [modal, setModal] = useState(visible);
  useEffect(() => setModal(visible), [visible]);
  const toggle = () => {
    onCancel();
    setModal(!modal);
  };

  return (
    <Modal size="lg" centered isOpen={modal} toggle={toggle} className="disclaimer">
      <ModalBody>
        <div className="disclaimer-icon col-md-3">
          {typeof icon !== "string" ? icon : icon && <span className={icon} />}
        </div>
        <div className="disclaimer-content col-md-9">
          <div className="disclaimer-title">{title}</div>
          <div className="disclaimer-text">{text}</div>
          <div className="disclaimer-footer">
            <TooltipButton
              buttonClassName="btn cp-btn cp-btn__medium"
              onClick={toggle}
              buttonText={cancelButtonText}
            />
            <TooltipButton
              buttonClassName="btn cp-btn__deleted cp-btn__medium"
              onClick={onAccept}
              buttonText={acepptButtonText}
            />
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

Disclaimer.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  acepptButtonText: PropTypes.string,
  cancelButtonText: PropTypes.string,
  onAccept: PropTypes.func,
  onCancel: PropTypes.func,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  visible: PropTypes.bool
};

Disclaimer.defaultProps = {
  title: "",
  text: "",
  acepptButtonText: "Aceptar",
  cancelButtonText: "Cancelar",
  onAccept: () => {},
  onCancel: () => {},
  icon: "",
  visible: false
};
export default Disclaimer;
